import { PAYSLIP_FETCHING, PAYSLIP_FAILED, PAYSLIP_SUCCESS } from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case PAYSLIP_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case PAYSLIP_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case PAYSLIP_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
};
